import { motion } from "framer-motion";
import { waDefaultLink } from "@/lib/site";
import { WhatsAppIcon } from "./Footer";

export default function WhatsAppFloat() {
  return (
    <motion.a
      href={waDefaultLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat with us on WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-wa text-white shadow-[0_8px_30px_rgba(37,211,102,0.4)]"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-wa opacity-20" />
      <WhatsAppIcon className="h-6 w-6" />
    </motion.a>
  );
}
